export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20dark%20technology%20background%20with%20abstract%20digital%20data%20streams%2C%20glowing%20blue%20circuit%20lines%2C%20deep%20navy%20and%20black%20tones%2C%20futuristic%20AI%20concept%2C%20professional%20corporate%20atmosphere%2C%20high%20contrast%20dark%20background%20with%20subtle%20blue%20light%20accents%2C%20no%20people%2C%20clean%20minimal%20tech%20aesthetic&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>
        <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at 60% 40%, rgba(14,165,233,0.15) 0%, transparent 60%)' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 md:px-10 text-center py-32">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-sky-400/40 bg-sky-400/10 mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-sky-400 animate-pulse"></span>
          <span className="text-sky-300 text-xs font-semibold tracking-widest uppercase">Inteligência Artificial Trabalhista</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
          Cálculos Trabalhistas<br />
          <span className="text-transparent bg-clip-text" style={{ backgroundImage: 'linear-gradient(90deg, #38bdf8, #7dd3fc)' }}>
            com Precisão de IA
          </span>
        </h1>

        <p className="text-lg md:text-xl text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed">
          A Exato Cálculos resolve qualquer demanda trabalhista com alto nível técnico, segurança jurídica e tecnologia de inteligência artificial exclusiva — do cálculo à liquidação de sentença.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollTo('contato')}
            className="px-8 py-4 rounded-xl text-white font-semibold text-base cursor-pointer whitespace-nowrap transition-all duration-200 hover:-translate-y-1"
            style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)' }}
          >
            <span className="inline-flex items-center gap-2">
              <i className="ri-send-plane-line"></i>
              Solicitar Orçamento
            </span>
          </button>
          <button
            onClick={() => scrollTo('sobre')}
            className="px-8 py-4 rounded-xl text-white font-semibold text-base cursor-pointer whitespace-nowrap border border-white/30 bg-white/10 hover:bg-white/20 transition-all duration-200"
          >
            <span className="inline-flex items-center gap-2">
              <i className="ri-play-circle-line"></i>
              Falar com Especialista
            </span>
          </button>
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
          {[
            { value: '100K+', label: 'Cálculos Realizados' },
            { value: '19', label: 'Anos de Experiência' },
            { value: '99.8%', label: 'Precisão Técnica' },
          ].map((stat) => (
            <div key={stat.label} className="text-center px-6 py-5 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm">
              <div className="text-3xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-sm text-white/50">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <span className="text-white/40 text-xs">scroll</span>
        <i className="ri-arrow-down-line text-white/40"></i>
      </div>
    </section>
  );
}
